import { ActionType } from '../../constants/ActionTypes'

export default function seoSchemaReducer(state = {}, action = {}) {

    switch (action.type) {
        // case ActionType.GET_SEO_SETTINGS_BEGIN:
        //     return {
        //         ...state,
        //     }
        case ActionType.GET_SEO_SCHEMA_SUCCESS:
            return {
                ...state,
                [action.payload.lang]: action.payload.data
            }
        // case ActionType.GET_SEO_SETTINGS_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload
        //     }
        default:
            return state;
    }

}

